// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store/common'
import router from './router'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
import './style/font-awesome-4.7.0/css/font-awesome.min.css'
import locale from 'element-ui/lib/locale/lang/en'

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

import $ from 'jquery'

window.vueEvent = new Vue()

// 注册图片上传指令
Vue.directive('imageupload', {
  bind: function (el, binding, vnode) {
    let $el = $(el)
    $el.on('click', () => {
      window.Mc.showImgUpload(() => {
        window.vueEvent.$off('upload:success').$on('upload:success', (data) => {
          vnode.data.on['upload-change'](data.url, data)
          // vnode.data.on['upload-success'](url)
        })
      })
    })
  },
  inserted: function (el, binding, vnode) {
    // if (binding.value) {
    //   vnode.data.on['upload-change'](binding.value)
    // }
  },
  update: function (el, binding, vnode) {
    // if (binding.value === binding.oldValue) return
    // let value = binding.value ? binding.value : ''
    // vnode.data.on['upload-change'](value)
  },
  componentUpdated: function (el, binding, vnode) {},
  unbind: function (el, binding, vnode) {}
})

// 注册文件上传指令
Vue.directive('fileupload', {
  bind: function (el, binding, vnode) {
    // console.log("select:bind")
    let $el = $(el)
    $el.on('click', () => {
      window.Mc.showFileUpload(() => {
        window.vueEvent.$off('upload:success').$on('upload:success', (data) => {
          vnode.data.on['upload-change'](data.url, data)
          // vnode.data.on['upload-success'](url)
        })
      })
    })
  },
  inserted: function (el, binding, vnode) {
    // if (binding.value) {
    //   vnode.data.on['upload-change'](binding.value)
    // }
  },
  update: function (el, binding, vnode) {
    // if (binding.value === binding.oldValue) return
    // let value = binding.value ? binding.value : ''
    // vnode.data.on['upload-change'](value)
  },
  componentUpdated: function (el, binding, vnode) {},
  unbind: function (el, binding, vnode) {}
})

// 注册文件上传指令 - k3询价excel上传
Vue.directive('fileuploadk3', {
  bind: function (el, binding, vnode) {
    // console.log("select:bind")
    let $el = $(el)
    $el.on('click', () => {
      window.Mc.showFileUploadK3(() => {
        window.vueEvent.$off('upload:success').$on('upload:success', (data) => {
          vnode.data.on['upload-change'](data)
          // vnode.data.on['upload-success'](url)
        })
      })
    })
  },
  inserted: function (el, binding, vnode) {
    // if (binding.value) {
    //   vnode.data.on['upload-change'](binding.value)
    // }
  },
  update: function (el, binding, vnode) {
    // if (binding.value === binding.oldValue) return
    // let value = binding.value ? binding.value : ''
    // vnode.data.on['upload-change'](value)
  },
  componentUpdated: function (el, binding, vnode) {
  },
  unbind: function (el, binding, vnode) {
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js